// English + Odia translations for UI labels.
export const STRINGS = {
    en: {
        appName: "Odisha LO Portal",
        appSubtitle: "Learning Outcome Code Repository",
        searchPlaceholder: "Search LO codes, descriptions, keywords...",
        voiceSearch: "Voice search",
        browse: "Browse",
        classes: "Classes",
        subjects: "Subjects",
        search: "Search",
        bookmarks: "Bookmarks",
        analytics: "Analytics",
        admin: "Admin",
        home: "Home",
        dashboard: "Dashboard",
        totalClasses: "Total Classes",
        totalSubjects: "Total Subjects",
        totalLOCodes: "Total LO Codes",
        recentSearches: "Recent Searches",
        popularCodes: "Popular Codes",
        quickAccess: "Quick Access",
        browseByClass: "Browse by Class",
        browseBySubject: "Browse by Subject",
        searchLO: "Search LO Codes",
        loCount: "LO Codes",
        viewDetails: "View Details",
        copy: "Copy",
        copied: "Copied!",
        share: "Share",
        bookmark: "Bookmark",
        bookmarked: "Bookmarked",
        removeBookmark: "Remove",
        print: "Print",
        download: "Download",
        export: "Export",
        relatedCodes: "Related LO Codes",
        filterByClass: "Filter by Class",
        filterBySubject: "Filter by Subject",
        clearFilters: "Clear",
        noResults: "No results found",
        loading: "Loading...",
        classN: (n) => `Class ${n}`,
        codes: "codes",
        backToHome: "Back to Home",
        switchLang: "ଓଡ଼ିଆ",
        darkMode: "Dark mode",
        lightMode: "Light mode",
        adminTitle: "Admin Panel",
        adminDesc: "Re-process the LO PDF or upload a new one to refresh the database.",
        uploadPdf: "Upload PDF",
        reparse: "Re-parse seed PDF",
        replaceAll: "Replace all existing entries",
        getStarted: "Get Started",
        heroTitle: "Odisha Learning Outcome Portal",
        heroSubtitle: "Class-wise & Subject-wise Learning Outcome Code Repository",
        heroDesc: "Browse, search and export every LO Code for Classes 1–8 in Odia and English.",
        exploreClasses: "Explore Classes",
        searchNow: "Search Now",
        exportAll: "Export All",
        description: "Description",
        code: "Code",
        class: "Class",
        subject: "Subject",
        viewAll: "View all",
    },
    od: {
        appName: "ଓଡ଼ିଶା LO ପୋର୍ଟାଲ",
        appSubtitle: "ଶିକ୍ଷଣଲବ୍ଧି କୋଡ୍ ସଂଗ୍ରହ",
        searchPlaceholder: "LO କୋଡ୍, ବର୍ଣ୍ଣନା, ଶବ୍ଦ ଖୋଜନ୍ତୁ...",
        voiceSearch: "ସ୍ୱର ଖୋଜ",
        browse: "ଖୋଜନ୍ତୁ",
        classes: "ଶ୍ରେଣୀ",
        subjects: "ବିଷୟ",
        search: "ଖୋଜ",
        bookmarks: "ବୁକମାର୍କ",
        analytics: "ବିଶ୍ଳେଷଣ",
        admin: "ପ୍ରଶାସକ",
        home: "ମୂଳପୃଷ୍ଠା",
        dashboard: "ଡ୍ୟାସବୋର୍ଡ",
        totalClasses: "ସର୍ବମୋଟ ଶ୍ରେଣୀ",
        totalSubjects: "ସର୍ବମୋଟ ବିଷୟ",
        totalLOCodes: "ସର୍ବମୋଟ LO କୋଡ୍",
        recentSearches: "ସମ୍ପ୍ରତି ଖୋଜା",
        popularCodes: "ଲୋକପ୍ରିୟ କୋଡ୍",
        quickAccess: "ଶୀଘ୍ର ପ୍ରବେଶ",
        browseByClass: "ଶ୍ରେଣୀ ଅନୁସାରେ",
        browseBySubject: "ବିଷୟ ଅନୁସାରେ",
        searchLO: "LO କୋଡ୍ ଖୋଜ",
        loCount: "LO କୋଡ୍",
        viewDetails: "ବିବରଣୀ ଦେଖ",
        copy: "କପି",
        copied: "କପି ହେଲା!",
        share: "ସେୟାର",
        bookmark: "ବୁକମାର୍କ",
        bookmarked: "ବୁକମାର୍କ ହୋଇଛି",
        removeBookmark: "ହଟାନ୍ତୁ",
        print: "ପ୍ରିଣ୍ଟ",
        download: "ଡାଉନଲୋଡ୍",
        export: "ଏକ୍ସପୋର୍ଟ",
        relatedCodes: "ସମ୍ବନ୍ଧୀୟ LO କୋଡ୍",
        filterByClass: "ଶ୍ରେଣୀ ଫିଲ୍ଟର",
        filterBySubject: "ବିଷୟ ଫିଲ୍ଟର",
        clearFilters: "ସଫା",
        noResults: "କୌଣସି ଫଳ ମିଳିଲା ନାହିଁ",
        loading: "ଲୋଡ୍ ହେଉଛି...",
        classN: (n) => `ଶ୍ରେଣୀ ${n}`,
        codes: "କୋଡ୍",
        backToHome: "ମୂଳପୃଷ୍ଠାକୁ ଫେରନ୍ତୁ",
        switchLang: "English",
        darkMode: "ଡାର୍କ ମୋଡ୍",
        lightMode: "ଲାଇଟ୍ ମୋଡ୍",
        adminTitle: "ପ୍ରଶାସକ ପ୍ୟାନେଲ",
        adminDesc: "LO PDF ପୁନର୍ବାର ପ୍ରକ୍ରିୟା କରନ୍ତୁ କିମ୍ବା ନୂତନ PDF ଅପଲୋଡ କରନ୍ତୁ ।",
        uploadPdf: "PDF ଅପଲୋଡ",
        reparse: "ସିଡ୍ PDF ପୁନଃପଢ଼",
        replaceAll: "ସମସ୍ତ ବର୍ତ୍ତମାନର ତଥ୍ୟ ବଦଳାନ୍ତୁ",
        getStarted: "ଆରମ୍ଭ କରନ୍ତୁ",
        heroTitle: "ଓଡ଼ିଶା ଶିକ୍ଷଣଲବ୍ଧି ପୋର୍ଟାଲ",
        heroSubtitle: "ଶ୍ରେଣୀ ଓ ବିଷୟ ଆଧାରିତ LO କୋଡ୍ ଭଣ୍ଡାର",
        heroDesc: "ଶ୍ରେଣୀ ୧-୮ ର ସମସ୍ତ LO କୋଡ୍ ଓଡ଼ିଆ ଓ ଇଂରାଜୀରେ ଖୋଜ, ଦେଖ ଓ ଏକ୍ସପୋର୍ଟ କରନ୍ତୁ ।",
        exploreClasses: "ଶ୍ରେଣୀ ଅନ୍ୱେଷଣ",
        searchNow: "ଏବେ ଖୋଜ",
        exportAll: "ସବୁ ଏକ୍ସପୋର୍ଟ",
        description: "ବର୍ଣ୍ଣନା",
        code: "କୋଡ୍",
        class: "ଶ୍ରେଣୀ",
        subject: "ବିଷୟ",
        viewAll: "ସବୁ ଦେଖ",
    },
};

// Subject name translations
export const SUBJECT_NAMES = {
    en: {
        Odia: "Odia",
        English: "English",
        Mathematics: "Mathematics",
        EVS: "EVS",
        Science: "Science",
        "Social Science": "Social Science",
    },
    od: {
        Odia: "ଓଡ଼ିଆ",
        English: "ଇଂରାଜୀ",
        Mathematics: "ଗଣିତ",
        EVS: "ପରିବେଶ ଅଧ୍ୟୟନ",
        Science: "ବିଜ୍ଞାନ",
        "Social Science": "ସମାଜ ବିଜ୍ଞାନ",
    },
};
